<template>
  <div class="modal-backdrop" v-if="visible">
    <div class="modal newsletter">
        <div class="modal-close" @click="hide()">
            <span class="icon"><img src="/Assets/img/cancel.svg" /></span>
        </div>
        <div class="modal-image"><img :src="settings.logoUrl"></div>
        <div class="modal-contents" v-show="!showThankYouMessage">
            <div class="modal-header">
                <div>Signup for Our Daily Deals</div>
                <div class="subtext">Sign up and you'll receive the best deals of the day</div>
            </div>
            <div class="modal-body">
                <div >
                    <div class="input-group">
                        <input v-model="vm.email" class="textbox" placeholder="Your Email" name="email" v-validate="'required|email'" />
                        <span v-show="errors.has('email')" class="is-error">{{ errors.first('email') }}</span>
                    </div>
                    <div class="input-group">
                        <input v-model="vm.name" class="textbox" placeholder="Your Name" name="name" />
                    </div>
                </div>
                
            </div>
            <div class="modal-footer">
                <div class="modal-buttons" v-show="!showThankYouMessage">
                    <button v-show="!isBusy" class="button button-modal" @click="submit()" :disabled="isBusy == true || !(this.fieldsValid)">Subscribe to {{settings.siteNameCaps}}</button>
                    <button v-show="isBusy" class="button button-modal button-busy"><span class="icon"><img src="/Assets/img/spin.svg" /></span></button>
                </div>
                <div class="made-with-love">Made with <b>Love</b></div>
            </div>
        </div>
        <div v-show="showThankYouMessage" class="modal-contents">
            <div class="modal-header text-success">
                <div>Done!</div>
                <div class="subtext">Thanks for signing up for our daily-deals!</div>
            </div>
            <div class="modal-footer">
                <div class="modal-buttons">
                    <button class="button button-modal button-success" @click="hide()">Close</button>
                </div>
                
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import Modal from './NewsletterModal.js';
    import settings from '@/settings';
    import api from "@/api";

    export default {
        data(){
            return {
                isBusy: false,
                showThankYouMessage: false,
                vm: {
                    email: null,
                    name: null,
                    giveaway: null
                },
                visible: false,
                title: '',
                text: '',
                onConfirm: {},
                onCancel: {}
            }
        },
        name: 'newsletter-modal',
        methods: {
            load(params) {
                if(params.giveaway)
                    this.vm.giveaway = params.giveaway;

                this.visible = true;
            },
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result){
                        this.isBusy = true;
                        api.newsletterSignup(this.vm).then(() => {
                            this.isBusy = false;
                            this.showThankYouMessage = true;    
                        });
                    }
                });
                
            },
            hide() {
                this.visible = false;
            },
            fieldsValid: function() { 
                
            }
        },
        beforeMount() {
            Modal.EventBus.$on('show', (params) => {
                this.load(params);
            });
        },
        computed: {
            settings: function(){ return settings; },
            
        }
    };
</script>